import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { TooltipDefinition } from "carbon-components-react";

import BaseTable from "web_modules/shared/BaseTable";
import { AppSearchData } from "@eave/shared/types/api";

const styles = require("./styles.module.scss");

interface HomepageProps {
  apps: AppSearchData[];
}

const Homepage: React.FC<HomepageProps> = ({ apps }) => {
  if (!apps.length) {
    return (
      <div id="settlement-agent-homepage" className={styles.homepage}>
        No applications found
      </div>
    );
  }
  const createTooltip = (label, tooltip) => {
    return <TooltipDefinition tooltipText={tooltip}>{label}</TooltipDefinition>;
  };

  return (
    <div id="settlement-agent-homepage" className={styles.homepage}>
      <BaseTable
        openModal={() => {}}
        disableAllControls
        title="Loan Applications"
        headerData={[
          {
            header: "Link",
            key: "link",
          },
          {
            header: createTooltip(
              "IR loan number",
              "Incoming Residence (IR) is the residence that the client will be purchasing with funds from the Departing Residence (DR). IR loan number is the loan number for the HomeLight Home Loans mortgage for teh borrower's new incoming residence",
            ),
            key: "external_id",
          },
          {
            header: createTooltip(
              "DR seller(s)",
              "Departing Residence (DR) is the residence that the client will be selling in order to purchase the Incoming Residence (IR). DR seller is the incoming residence buyer and loan applicant.",
            ),
            key: "names",
          },
          {
            header: createTooltip(
              "DR seller(s) email",
              "Departing Residence (DR) is the residence that the client will be selling in order to purchase the Incoming Residence (IR). DR seller email is the same email address as the incoming residence buyer and loan applicant.",
            ),
            key: "emails",
          },
          {
            header: createTooltip(
              "DR property",
              "Departing Residence (DR) is the residence that the client will be selling in order to purchase the Incoming Residence (IR). DR property is the address of the departing residence being sold.",
            ),
            key: "departing_residence_address",
          },
        ]}
        rowData={apps.map(app => ({
          id: app.id.toString(),
          external_id: app.external_id || "-",
          names: (
            <td key={`${app.id}_names`}>
              <div>
                {app.borrower1_first_name} {app.borrower1_last_name}
              </div>
              {app.borrower2_first_name && (
                <div>
                  {app.borrower2_first_name} {app.borrower2_last_name}
                </div>
              )}
            </td>
          ),
          emails: (
            <td key={`${app.id}_emails`}>
              <div>{app.borrower1_email}</div>
              {app.borrower2_email && <div>{app.borrower2_email}</div>}
            </td>
          ),
          departing_residence_address: (
            <td key={`${app.id}_departing_residence_address`}>
              {app.departing_residence_address || "-"}
            </td>
          ),
          link: (
            <td key={`${app.id}_link`}>
              <Link to={`/settlement-agent/app/${app.id}`} target="_blank">
                Open loan
              </Link>
            </td>
          ),
        }))}
      />
    </div>
  );
};

const mapStateToProps = state => {
  const apps = state.operatorHomepage && state.operatorHomepage.searchData;
  return {
    apps,
  };
};

export default connect<any, any, any>(mapStateToProps)(Homepage);
